export const SELECTED_COMPANY = 'SELECTED_COMPANY';
export const SELECTED_COMPANY_DATA = 'SELECTED_COMPANY_DATA';
export const SELECTED_SUB_COMPANY = 'SELECTED_SUB_COMPANY';
export const RESET_COMPANY = 'RESET_COMPANY';

export function setSelectedCompany(data) {
	return async dispatch => {
		dispatch({
			type: SELECTED_COMPANY,
			data
		});
	};
};

export function setSelectedCompanyData(data) {
	return async dispatch => {
		dispatch({
			type: SELECTED_COMPANY_DATA,
			data
		});
	};
};

export function setSelectedSubCompany(data) {
	return async dispatch => {
		dispatch({
			type: SELECTED_SUB_COMPANY,
			data
		});
	};
};

export function resetCompany() {
	return dispatch => {
		dispatch({ type: RESET_COMPANY });
	};
};